// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"615":"4ecf317cf4f9a6ed","888":"a27f4815fe2558a6"}[chunkId] + ".css";
};